import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
// @ts-ignore
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const DashboardChart: React.FC = () => {
  const data = {
    labels: [
      '25%',
      '50% (медиана)',
      '75%'
    ],
    datasets: [{
      label: 'Условный уровень оплаты (₽)',
      data: [1000000, 2000000, 2500000],
      backgroundColor: [
        'rgba(26, 35, 126, 0.4)',
        'rgba(26, 35, 126, 0.6)',
        'rgba(26, 35, 126, 0.8)'
      ],
      borderColor: [
        'rgba(26, 35, 126, 0.5)',
        'rgba(26, 35, 126, 0.7)',
        'rgba(26, 35, 126, 0.9)'
      ],
      borderWidth: 1
    }]
  };

  const options = {
    indexAxis: 'y' as const,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          label: function(context: any) {
            let value = context.raw;
            return `${value.toLocaleString('ru-RU')} ₽`;
          }
        }
      },
      datalabels: {
        display: false
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          callback: function(value: any) {
            return value.toLocaleString('ru-RU');
          }
        }
      },
      y: {
        title: {
          display: true,
          text: 'Перцентили'
        }
      }
    }
  };

  return <Bar data={data} options={options} />;
};

export default DashboardChart;
